import type { DashboardTemplate } from './dashboardTemplate.types';

// Eight components: three totals cards over a full-width time-series line, then two rows pairing a
// 2-wide chart with a 1-wide one. It is the showcase for the chart types, so every chart here
// resolves to real data and each one exercises something different:
//
// - the line is two series over `measurement_date` (as-of history) with area fill, a legend and a
//   1Y default time range;
// - the horizontal bar is `dimension: company_name` — one bar per company, ranked, "Other" folded;
// - the pie is `fund_name`, so the slices are per-fund sums of `total_value` (a SUM metric, which is
//   what a pie requires);
// - the grouped bar puts two series side by side per fund;
// - "MOIC by valuation status" is a ratio recomputed per group from summed operands, not averaged.
//
// Nothing asks for financial periods: that axis is unsupported and would render a reason instead of
// a chart. The cards cover both comparison modes ("vs prior period", "vs entry").
//
// Checked against a live generation: valid on the first pass, all eight components resolve.
export const chartsTemplate: DashboardTemplate = {
  id: 'charts',
  title: 'Performance Trends',
  description: 'KPI cards over a value trend line, with company, fund and status breakdown charts.',
  prompt: `Build a performance trends dashboard on a 3-column layout.

Open with three 1x1 totals cards with accent bars: total value and invested capital vs prior period, MOIC vs entry.

Below them a full-width area line chart of total value and invested capital over measurement dates, with a legend and a 3M/6M/1Y/ALL time range defaulting to 1Y.

Then two rows of a 2-wide chart beside a 1-wide chart: a horizontal bar chart ranking companies by total value beside a pie chart of total value by fund; then a bar chart of total value and invested capital by fund with a legend, beside a bar chart of MOIC by valuation status.`,
  preview: [{ w: 1 }, { w: 1 }, { w: 1 }, { w: 3 }, { w: 2 }, { w: 1 }, { w: 2 }, { w: 1 }],
};
